import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { createVariants } from './_variants';

const searchBarClasses = createVariants({
  base:
    'flex items-center rounded-full transition-theme duration-theme w-full focus-within:ring-2 focus-within:ring-succession-focus-ring',
  variants: {
    primary:
      'bg-succession-bg-primary border border-succession-border hover:border-succession-border-hover',
    // Outline matches header: tokenized page surface with border only
    outline:
      'bg-succession-bg-primary border border-succession-border hover:border-succession-border-hover',
    ghost:
      'bg-transparent border border-transparent hover:border-succession-border',
  },
  sizes: {
    sm: 'h-8 px-3 text-sm',
    md: 'h-9 px-3 text-sm',
    lg: 'h-12 px-4 text-base',
  },
  defaultVariant: 'outline',
  defaultSize: 'md',
});

const SearchBar = ({
  value,
  defaultValue = '',
  onChange,
  onSubmit,
  placeholder = 'Search for opportunties',
  variant = 'outline',
  size = 'md',
  className,
  actionHref, // optional convenience fallback
}) => {
  const [internal, setInternal] = useState(defaultValue);
  const val = value != null ? value : internal;

  const handleChange = (e) => {
    if (onChange) onChange(e.target.value);
    else setInternal(e.target.value);
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    const q = (val || '').trim();
    if (!q) return;
    if (onSubmit) onSubmit(q);
    else if (actionHref) window.location.href = `${actionHref}${encodeURIComponent(q)}`;
  };

  return (
    <form className="w-full" onSubmit={handleSubmit}>
      <div className={searchBarClasses({ variant, size, className })}>
        <MagnifyingGlassIcon className="h-4 w-4 mr-2 text-succession-text-secondary" />
        <input
          type="text"
          value={val}
          onChange={handleChange}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(e); }}
          placeholder={placeholder}
          className="canon-search-input bg-transparent border-none focus:ring-0 focus:outline-none leading-none w-full text-succession-text-primary placeholder-succession-text-muted p-0"
        />
      </div>
      {/* Ensure canon search input is transparent and unstyled, matching Header */}
      <style>{`
        .canon-search-input{background-color:transparent!important;border:none!important;box-shadow:none!important;outline:none!important;-webkit-appearance:none;appearance:none;padding:0!important;height:auto!important}
        .canon-search-input::placeholder{color:var(--succession-text-muted)!important}
      `}</style>
    </form>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  placeholder: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'outline', 'ghost']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  actionHref: PropTypes.string,
};

export default SearchBar;


